// system libraries
import Vue from 'vue';
// import App from './App.vue'
import AppV2 from './AppV2.vue';
import VueRouter from 'vue-router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
//const BootstrapVue = () => import('bootstrap-vue').BootstrapVue
//const IconsPlugin = () => import('bootstrap-vue').IconsPlugin
import Vuetify from 'vuetify';
// import firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import Loading from 'vue-loading-overlay';
import { Datetime } from 'vue-datetime';
import { Settings } from 'luxon';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-datetime/dist/vue-datetime.css';

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'bootstrap-vue/dist/bootstrap-vue-icons.css'
// import '@/styles/main.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Toast from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';
import moment from 'moment';
import './plugins/moment';
Vue.config.devtools = true;
// router
import router from '@/routes';
import store from '@/store';

// plugins
import EventBus from '@/plugins/event_bus';
import vuetify from './plugins/vuetify';
//import VueTelInputVuetify from 'vue-tel-input-vuetify'
import i18n from './plugins/vue-i18n';
//import a from './plugins/firebase'

// views
//import Error403 from '@/views/403.vue'
//import Error404 from '@/views/404.vue'
//import MainSearch from '@/views/MainSearch.vue' // es componente
//import ContLogin from '@/views/ContLogin.vue'
//import ContLoadBulk from '@/views/ContLoadBulk.vue'
//import ContMonitoring from '@/views/ContMonitoring.vue'
//import ContDataDashboard from '@/views/ContDataDashboard.vue'
//import ContDlpDashboard from '@/views/ContDlpDashboard.vue'
//import ContLineageIframes from '@/views/ContLineageIframes.vue'
//import ContAssignments from '@/views/ContAssignments.vue'
// import ContMyTables from '@/views/ContMyTables.vue'
//import ContMyActivity from '@/views/ContMyActivity.vue'
//import ContTablesAccessRequested from '@/views/ContTablesAccessRequested.vue'
//import ContTablesChangeMetadataRequested from '@/views/ContTablesChangeMetadataRequested.vue'
//import ContPendingAssignmentsMe from '@/views/ContPendingAssignmentsMe.vue'
//import ContObjectSearch from '@/views/ContObjectSearch.vue'

// components
//import MainMenu from '@/components/MainMenu.vue'
//import UserMenu from '@/components/UserMenu.vue'
//import SearchInTable from '@/components/SearchInTable.vue'
//import FilterInTable from '@/components/FilterInTable.vue'
//import Pagination from '@/components/Pagination.vue'
import PaginationVue from '@/components/PaginationVue.vue';
import PaginationFirestore from '@/components/PaginationFirestore.vue';
//import ListObjectSearch from '@/components/ListObjectSearch.vue'

//import ListTableMetadataCols from '@/components/ListTableMetadataCols.vue'
//import ListTableLogs from '@/components/ListTableLogs.vue'
//import FormAccessRequest from '@/components/FormAccessRequest.vue'
//import FormRequestDatasource from '@/components/FormRequestDatasource.vue'
//import FormAccessResponse from '@/components/FormAccessResponse.vue'
//import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue'
//import FormLineageRequest from '@/components/FormLineageRequest.vue'
//import FormMetadata from '@/components/FormMetadata.vue'
//import FormBusinessTerms from '@/components/FormBusinessTerms.vue'
//import TabMetadataBusinessTerms from '@/components/TabMetadataBusinessTerms.vue'
//import FormMetadataChangeResponse from '@/components/FormMetadataChangeResponse.vue'
//import InformMassiveUpload from '@/components/InformMassiveUpload.vue'

// import ContMyTables from '@/views/refactoring/ContMyTables.vue'
//import SearchInTableNew from '@/components/refactoring/SearchInTable.vue'
//import FormSearching from '@/components/refactoring/FormSearching.vue'
//import PaginationSearching from '@/components/refactoring/PaginationSearching.vue'

//import PxLabel from '@/components/refactoring/PxLabel'
//import PxCheck from '@/components/refactoring/PxCheck'
//import PxText from '@/components/refactoring/PxText'
//import PxSelect from '@/components/refactoring/PxSelect'
//import BusinessTerm from '@/views/BusinessTerm.vue'
//import SearchBusinessTerm from '@/components/SearchBusinessTerm.vue'
//import PaginationBasic from '@/components/PaginationBasic.vue'
//import BaseLoadingComponent from '@/components/common/BaseLoadingComponent'
import MessageComponent from '@/components/MessageComponent.vue';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import ActionsComponent from '@/components/ActionsComponent.vue';
import CommonInputComponent from '@/components/common/CommonInputComponent.vue';
import CommonSelectComponent from '@/components/common/CommonSelectComponent.vue';
import CommonDateRangeComponent from '@/components/common/CommonDateRangeComponent.vue';
import CommonFilterGridComponent from '@/components/common/CommonFilterGridComponent.vue';

//import StateComponent from '@/components/StateComponent.vue'
//import PaginationCatalog from '@/components/PaginationCatalog.vue'
//import OrganizacionComponent from '@/components/OrganizacionComponent.vue'
//import CaptchaComponent from '@/components/CaptchaComponent.vue'

import './plugins/vue-shortkey';
import './plugins/vue-head';
// STYLES
// Main Theme SCSS
import './assets/scss/theme.scss';

// Animation library - https://animate.style/
import 'animate.css/animate.min.css';
Settings.defaultLocale = 'es';
Vue.component('DialogsComponent', DialogsComponent);
//Vue.component('FormSearching', FormSearching)
//Vue.component('SearchInTableNew', SearchInTableNew)
//Vue.component('PaginationSearching', PaginationSearching)
//Vue.component('PxLabel', PxLabel)
//Vue.component('PxCheck', PxCheck)
//Vue.component('PxText', PxText)
//Vue.component('PxSelect', PxSelect)

// register componets and views
// TODO: validatw if is requires load alp components
//Vue.component('Cont403', Error403)
//Vue.component('Cont404', Error404)
// Vue.component('ContLogin', ContLogin)
// Vue.component('UserMenu', UserMenu)
// Vue.component('MainMenu', MainMenu)
//Vue.component('MainSearch', MainSearch)
//Vue.component('SearchInTable', SearchInTable)
//Vue.component('FilterInTable', FilterInTable)
//Vue.component('Pagination', Pagination)
//Vue.component('ContAssignments', ContAssignments)
//Vue.component('ContPendingAssignmentsMe', ContPendingAssignmentsMe)
//Vue.component('ContMyTables', ContMyTables)
//Vue.component('ContMyActivity', ContMyActivity)
//Vue.component('ContLoadBulk', ContLoadBulk)
//Vue.component('ContMonitoring', ContMonitoring)
//Vue.component('ContDataDashboard', ContDataDashboard)
//Vue.component('ContDlpDashboard', ContDlpDashboard)
//Vue.component('ContLineageIframes', ContLineageIframes)
//Vue.component('ContObjectSearch', ContObjectSearch)
//Vue.component('BusinessTerm', BusinessTerm)
//Vue.component('ContTablesAccessRequested', ContTablesAccessRequested)
//Vue.component('ContTablesChangeMetadataRequested', ContTablesChangeMetadataRequested)
//Vue.component('ListObjectsSearch', ListObjectSearch)
//Vue.component('ListTableMetadataCols', ListTableMetadataCols)
//Vue.component('ListTableLogs', ListTableLogs)
//Vue.component('FormAccessRequest', FormAccessRequest)
//Vue.component('FormAccessResponse', FormAccessResponse)
//Vue.component('FormAssignTemporalOwner', FormAssignTemporalOwner)
//Vue.component('FormLineageRequest', FormLineageRequest)
//Vue.component('FormMetadata', FormMetadata)
//Vue.component('FormBusinessTerms', FormBusinessTerms)
//Vue.component('TabMetadataBusinessTerms', TabMetadataBusinessTerms)
//Vue.component('FormMetadataChangeResponse', FormMetadataChangeResponse)
//Vue.component('InformMassiveUpload', InformMassiveUpload)
//Vue.component('FormRequestDatasource', FormRequestDatasource)
Vue.component('Loading', Loading);
Vue.component('datetime', Datetime);
//Vue.component('SearchBusinessTerm', SearchBusinessTerm)
//Vue.component('PaginationBasic', PaginationBasic)
//Vue.component('BaseLoadingComponent', BaseLoadingComponent)
Vue.component('MessageComponent', MessageComponent);
Vue.component('PaginationVue', PaginationVue);
Vue.component('DialogConfirmationComponent', DialogConfirmationComponent);
Vue.component('PaginationFirestore', PaginationFirestore);
Vue.component('ActionsComponent', ActionsComponent);
Vue.component('CommonInput', CommonInputComponent);
Vue.component('CommonSelect', CommonSelectComponent);
Vue.component('CommonDateRange', CommonDateRangeComponent);
Vue.component('CommonFilterGrid', CommonFilterGridComponent);

//Vue.component("StateComponent", StateComponent)
//Vue.component("PaginationCatalog", PaginationCatalog)
//Vue.component("OrganizacionComponent", OrganizacionComponent)
//Vue.component("CaptchaComponent", CaptchaComponent)

import defaultLayout from './layouts/DefaultLayout';
//import simpleLayout from './layouts/SimpleLayout'
import authLayout from './layouts/AuthLayout';
//import errorLayout from './layouts/ErrorLayout'

Vue.component('defaultLayout', defaultLayout);
//Vue.component('simpleLayout', simpleLayout)
Vue.component('authLayout', authLayout);
//Vue.component('errorLayout', errorLayout)

// load utils and functions tasks
import filters from '@/js/filters';
import './filters/formatCurrency';
import VuetifyMask from 'vuetify-mask';
import VueGtag from 'vue-gtag';
import VueGtm from '@gtm-support/vue2-gtm';
var _router = new VueRouter({
  router: router
});
Vue.use(VuetifyMask);
import './filters/formatPercentage';

// use libraries for UI and routes
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(EventBus);
Vue.use(Vuetify);
/*Vue.use(VueTelInputVuetify, {
  vuetify
})*/
//console.log(process.env.VUE_APP_GA_ID)
//console.log(process.env.VUE_APP_GTM_ID)
//console.log(process.env.VUE_APP_API_GTW)
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID
  }
});
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  //queryParams: {
  // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //gtm_preview: 'env-4',
  //gtm_cookies_win: 'x',
  //},
  defer: false,
  // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false,
  // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c',
  // Will add `nonce` to the script tag
  enabled: true,
  // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true,
  // Whether or not display console logs debugs (optional)
  loadScript: true,
  // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router,
  // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [],
  // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});
var options = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 2,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
};
Vue.use(Toast, options);
import { mapActions } from 'vuex';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';

// declare main app after load firebase auth
import 'firebase/auth';
import { firebaseConfig, GA_EVENTS } from '@/js/constants';
import { userMixin } from '@/mixins/user';
import { globalMixin } from '@/mixins/global_mixins';
//import { createWrapper } from '@vue/test-utils'

try {
  firebase.initializeApp(firebaseConfig);
} catch (err) {
  if (!/already exists/.test(err.message)) {
    console.error('Firebase initialization error', err.stack);
  }
}
i18n.mergeLocaleMessage('es', {
  $vuetify: {
    input: {
      appendAction: '',
      clear: ''
    }
  }
});

/* firebase.auth().onAuthStateChanged(userLogin => {
  //console.log(userLogin)
  // register global mixin for view user in any html view
  Vue.mixin({
    data() {
      return {
        get userLogin() {
          window.userInfo = window.userInfo || {}
          window.userInfo.userLogin = userLogin || firebase.auth().currentUser
          return window.userInfo
        }
      }
    }
  })*/

// register global filters for transform data into views html
Vue.filter('formatDate', filters.formatDate);
Vue.filter('joinTableReference', filters.joinTableReference);
Vue.filter('formatNumber', filters.formatNumber);
Vue.filter('formatPercent', filters.formatPercent);
Vue.filter('stringLongFormatDateStick', filters.stringLongFormatDateStick);
Vue.filter('stringShortFormatDateStick', filters.stringShortFormatDateStick);
Vue.filter('timestampShortFormatDate', function (seconds) {
  return moment(new Date(seconds * 1000)).format('DD MMMM, YYYY ');
});
Vue.filter('stringShortFormatDate', function (str) {
  return moment(new Date(str)).format('DD MMMM, YYYY ');
});
Vue.filter('timestampLongFormatDate', function (seconds) {
  return moment(new Date(seconds * 1000)).format('DD MMMM, YYYY HH:mm');
});
Vue.filter('stringLongFormatDate', function (str) {
  return moment(new Date(str)).format('DD MMMM, YYYY HH:mm');
});
Vue.filter('stringGMTFormatDate', function (date_desc) {
  if (!date_desc) return '';
  return moment(new Date(date_desc)).format('DD/MM/YYYY HH:mm:ss');
});
Vue.mixin(userMixin);
Vue.mixin(globalMixin);
var firebaseMessaging = null;
if (firebase.messaging.isSupported()) {
  firebaseMessaging = firebase.messaging();
}
Vue.prototype.$messaging = firebaseMessaging;
var appCreated = false;
var initializedTables = new Map();
Vue.directive('scrollable-table', {
  inserted: function inserted(el) {
    var tableId = el.getAttribute('id') || Math.random().toString(36).substr(2, 9);
    el.setAttribute('id', tableId);
    var observer = new MutationObserver(function () {
      configureScrollButtons(el);
    });
    var config = {
      childList: true,
      subtree: true
    };
    var tableWrapper2 = el.querySelector('.v-data-table__wrapper');
    if (tableWrapper2) {
      observer.observe(tableWrapper2, config);
    }
    el._onDestroy = function () {
      observer.disconnect();
    };
    if (initializedTables.has(tableId)) {
      console.log("Tabla con ID ".concat(tableId, " ya est\xE1 inicializada."));
      return;
    }
    var tableWrapper = el.querySelector('.v-data-table__wrapper');
    if (tableWrapper) {
      createScrollButtons(el);
      configureScrollButtons(el);
      initializedTables.set(tableId, true);
      console.log("Tabla con ID ".concat(tableId, " inicializada."));
    } else {
      console.warn("No se encontr\xF3 .v-data-table__wrapper dentro del elemento.");
    }
  },
  unbind: function unbind(el) {
    var tableId = el.getAttribute('id');
    if (tableId && initializedTables.has(tableId)) {
      initializedTables.delete(tableId);
      console.log("Tabla con ID ".concat(tableId, " eliminada del seguimiento."));
    }
    if (el._onDestroy) el._onDestroy();
  }
});
function createScrollButtons(el) {
  var tableWrapper = el.querySelector('.v-data-table__wrapper');
  if (!tableWrapper) {
    console.warn('No se encontró .v-data-table__wrapper dentro del elemento.');
    return;
  }
  var leftButton = el.querySelector('.arrow-left');
  var rightButton = el.querySelector('.arrow-right');
  if (!leftButton) {
    leftButton = document.createElement('button');
    leftButton.className = 'arrow-left v-btn scroll-button';
    leftButton.innerHTML = '<i class="v-icon mdi mdi-arrow-left mdi-18px"></i>';
    leftButton.style.position = 'absolute';
    leftButton.style.top = '50%';
    leftButton.style.left = '0';
    leftButton.style.transform = 'translate(10px, -50%)';
    tableWrapper.parentElement.insertBefore(leftButton, tableWrapper);
  }
  if (!rightButton) {
    rightButton = document.createElement('button');
    rightButton.className = 'arrow-right v-btn scroll-button';
    rightButton.innerHTML = '<i class="v-icon mdi mdi-arrow-right mdi-18px" ></i>';
    rightButton.style.position = 'absolute';
    rightButton.style.top = '50%';
    rightButton.style.right = '0';
    rightButton.style.transform = 'translate(-10px, -50%)';
    tableWrapper.parentElement.appendChild(rightButton);
  }
}
function configureScrollButtons(el) {
  var tableWrapper = el.querySelector('.v-data-table__wrapper');
  var leftButton = el.querySelector('.arrow-left');
  var rightButton = el.querySelector('.arrow-right');
  if (!tableWrapper || !leftButton || !rightButton) return;
  var scrollInterval;
  var scrollLeft = function scrollLeft() {
    scrollInterval = setInterval(function () {
      tableWrapper.scrollBy({
        left: -200,
        behavior: 'smooth'
      });
    }, 100);
  };
  var scrollRight = function scrollRight() {
    scrollInterval = setInterval(function () {
      tableWrapper.scrollBy({
        left: 200,
        behavior: 'smooth'
      });
    }, 100);
  };
  var stopScroll = function stopScroll() {
    clearInterval(scrollInterval);
  };
  leftButton.addEventListener('mousedown', scrollLeft);
  rightButton.addEventListener('mousedown', scrollRight);
  leftButton.addEventListener('mouseup', stopScroll);
  rightButton.addEventListener('mouseup', stopScroll);
  leftButton.addEventListener('mouseleave', stopScroll);
  rightButton.addEventListener('mouseleave', stopScroll);
  var checkScrollAvailability = function checkScrollAvailability() {
    var scrollLeft = Math.round(tableWrapper.scrollLeft);
    var maxScrollLeft = Math.round(tableWrapper.scrollWidth - tableWrapper.clientWidth);
    leftButton.style.display = scrollLeft > 0 ? 'block' : 'none';
    rightButton.style.display = scrollLeft < maxScrollLeft ? 'block' : 'none';
  };
  tableWrapper.addEventListener('scroll', checkScrollAvailability);
  window.addEventListener('resize', checkScrollAvailability);
  checkScrollAvailability();
}
function createApp2() {
  if (appCreated) {
    return;
  }
  appCreated = true;
  // Start vue js app
  new Vue({
    el: '#app',
    data: function data() {
      return {
        // global user info var
        // userInfo: window.userInfo
      };
    },
    i18n: i18n,
    vuetify: vuetify,
    store: store,
    computed: {},
    created: function created() {
      var _this = this;
      console.log('created main');
      if (window.userInfo && window.userInfo.email) {
        // && window.userInfo.userRoles) {
        if (!window.userInfo.loading && !window.userInfo.userRoles) {
          //&& !window.userInfo.userRoles
          var userLogin = firebase.auth().currentUser;
          console.log(userLogin);
          var user = {
            email: userLogin.email ? userLogin.email.toLowerCase() : userLogin.email,
            uid: userLogin.uid,
            displayName: userLogin.displayName,
            emailVerified: userLogin.emailVerified,
            phoneNumber: userLogin.phoneNumber,
            photoURL: userLogin.photoURL,
            created: userLogin.metadata.creationTime,
            lastSignIn: userLogin.metadata.lastSignInTime
          };
          this.setLocale('es');
          UserSecurityService.loginUser(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid, user).then(function (res) {
            _this.$store.dispatch('analytic-services/setFlags', res.data.flags);
            _this.$store.dispatch('data-platform/setFlags', res.data.flags);
            var is_ad = res.data.is_ad;
            var type = 'google';
            if (is_ad && is_ad == "AZURE") {
              type = 'azure';
              /*userLogin.providerData.forEach((profile) => {
                if (profile.providerId == 'google.com') {
                  window.alert("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Office 365.")
                  //tasks.toast.error("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Microsoft.")
                  tasks.logoutApplication()
                }
              })*/
              userLogin.getIdTokenResult().then(function (idTokenResult) {
                var signInProvider = idTokenResult.signInProvider; // <-- ESTE ES EL DATO REAL
                console.log("Logueado actualmente con:", signInProvider);
                if (signInProvider == 'google.com') {
                  window.alert("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Office 365.");
                  //tasks.toast.error("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Microsoft.")
                  tasks.logoutApplication();
                }
              });
            }
            if (_this.$gtm.enabled() && window.dataLayer) {
              window.dataLayer.push({
                event: GA_EVENTS.LOGIN,
                eventName: GA_EVENTS.LOGIN,
                domain: res.data.domain,
                type: 'google',
                company_code: res.data.companyCode,
                hash_email: _this.stringToHash(user.email)
                // further parameters
              });
            }
            window.userInfo.loading = false;
            window.userInfo.userRoles = res.data.roles;
            //window.userInfo.listOrgs = res.data.list_orgs
            window.userInfo.domain = res.data.domain;
            //window.userInfo.orgs = res.data.orgs
            //window.userInfo.photoURL = userLogin.photoURL
            //window.userInfo.base_url = res.data.inca_base_url
            //window.userInfo.somos1_agreement=res.data.somos1_agreement
            _this.userInfo = window.userInfo;
            //console.log('load initial data 1')
            //this.$store.dispatch('data-platform/getLoginDetail', _this)
            UserSecurityService.loginDetail(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid, user).then(function (res2) {
              window.userInfo.listOrgs = res2.data.list_orgs;
              window.userInfo.orgs = res2.data.orgs;
              window.userInfo.photoURL = userLogin.photoURL;
              window.userInfo.base_url = res2.data.inca_base_url;
              window.userInfo.somos1_agreement = res2.data.somos1_agreement;
              _this.$store.commit('data-platform/setBaseUrl', res2.data.inca_base_url);
              _this.$store.commit('data-platform/setDefaultLanguage', res2.data.defaultLanguage);
              _this.$store.commit('data-platform/setCompanyCode', res2.data.companyCode);
              _this.$store.commit('data-platform/setCompanyName', res2.data.companyName);
              _this.$store.commit('data-platform/setOrgs', res2.data.orgs);
              _this.$store.commit('data-platform/setMessagingToken', res2.data.messagingToken);
              _this.$store.commit('data-platform/setDomainsOptional', res2.data.domains_optional);
              _this.setLocale(res2.data.defaultLanguage);
            });
            _this.$store.dispatch('data-platform/getSelectFields', window.userInfo.domain, null, {
              root: true
            });
            _this.$store.dispatch('data-platform/hideInitialSetupMenu', null, {
              root: true
            });
            _this.$store.dispatch('data-platform/getIsTableauActive', null, {
              root: true
            });
            _this.$store.dispatch('data-platform/getSynapseStatus', window.userInfo.domain, {
              root: true
            });
            _this.$store.dispatch('data-platform/getBigqueryStatus', window.userInfo.domain, {
              root: true
            });
            //this.$store.dispatch('data-platform/getCompanyCode', null, { root: true })
            _this.$store.dispatch('data-platform/getUserNotifications', userLogin.email, {
              root: true
            });
            _this.$store.dispatch('attribute/getCompanyAbrevs');
            _this.$store.dispatch('attribute/getLabelCatalog');
            _this.$store.dispatch('attribute/getStatusLogTypes');
            _this.$store.dispatch('attribute/getAttributeSourcesCatalog');
            _this.$store.dispatch('attribute/getSolicitudeTypes');
            _this.$store.dispatch('customer-insights/getInitialData');
            _this.$store.dispatch('audience/getCompanyFlags');
            _this.$store.dispatch('attribute/getCompanyFlags');
            _this.$store.dispatch('attribute/getUserNotifications');
            _this.$store.dispatch('attribute/getBusinessUserServiceAccounts', res.data.companyCode);
          });
        } else {
          //console.log('load initial data 2 ')
          this.$store.dispatch('data-platform/getSelectFields', window.userInfo.domain, null, {
            root: true
          });
          this.$store.dispatch('data-platform/hideInitialSetupMenu', null, {
            root: true
          });
          this.$store.dispatch('data-platform/getIsTableauActive', null, {
            root: true
          });
          this.$store.dispatch('data-platform/getSynapseStatus', window.userInfo.domain, {
            root: true
          });
          this.$store.dispatch('data-platform/getBigqueryStatus', window.userInfo.domain, {
            root: true
          });
          this.$store.dispatch('data-platform/getCompanyCode', null, {
            root: true
          });
          this.$store.dispatch('attribute/getCompanyAbrevs');
          this.$store.dispatch('attribute/getLabelCatalog');
          this.$store.dispatch('attribute/getStatusLogTypes');
          this.$store.dispatch('attribute/getAttributeSourcesCatalog');
          this.$store.dispatch('customer-insights/getInitialData');
          this.$store.dispatch('audience/getCompanyFlags');
          this.$store.dispatch('attribute/getCompanyFlags');
        }
      }
    },
    mounted: function mounted() {
      //console.log('mounted main')
      // on create validate user info
      // window.userInfo = tasks.getUserInfo()
      // window.userLogin = userLogin || firebase.auth().currentUser
    },
    router: router,
    render: function render(h) {
      return h(AppV2);
    }
  });
}
firebase.auth().onAuthStateChanged(function (userLogin) {
  //console.log(userLogin)
  window.userInfo = window.userInfo || {};
  window.userInfo.userLogin = userLogin || firebase.auth().currentUser;
  //console.log(userLogin)
  // register global mixin for view user in any html view
  Vue.mixin({
    data: function data() {
      return {
        get userLogin() {
          window.userInfo = window.userInfo || {};
          window.userInfo.userLogin = userLogin || firebase.auth().currentUser;
          //window.userInfo.userRoles = []
          return window.userInfo;
        },
        size_screen: 'lg'
      };
    },
    created: function created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    destroyed: function destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize: function handleResize() {
        var width = window.innerWidth;
        var height = window.innerHeight;
        this.size_screen = 'lg';
        if (width < 1920) this.size_screen = 'md';
        if (width < 960) this.size_screen = 'sm';
        if (width < 640) this.size_screen = 'xs';
      }
    }
  });
  createApp2();
}, function (err) {
  createApp2();
});
// })